import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 dark:bg-gray-900" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "p-6" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        _ctx.theme.isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
        'border-b px-6 py-4'
      ])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", {
            class: _normalizeClass([
              _ctx.theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
              'text-2xl font-bold'
            ])
          }, " Database ", 2),
          _createElementVNode("p", {
            class: _normalizeClass([
              _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-600',
              'mt-1 text-sm'
            ])
          }, " Common database actions and information for multiple databases ", 2)
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "/database/firestore",
          class: _normalizeClass([
            _ctx.theme.isDark.value ? 'bg-gray-800 border-gray-700 hover:bg-gray-700' : 'bg-white border-gray-200 hover:bg-gray-50',
            'border rounded-lg p-6 transition-colors cursor-pointer block'
          ])
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", {
              class: _normalizeClass([
              _ctx.theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
              'text-lg font-semibold mb-2'
            ])
            }, " Firestore ", 2),
            _createElementVNode("p", {
              class: _normalizeClass([
              _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-600',
              'text-sm'
            ])
            }, " View index definitions and index usage information for Firestore collections. ", 2),
            _createElementVNode("span", {
              class: _normalizeClass([
              _ctx.theme.isDark.value ? 'text-blue-400' : 'text-blue-600',
              'text-sm font-medium mt-2 inline-block'
            ])
            }, " Open Firestore → ", 2)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          to: "/database/mongo",
          class: _normalizeClass([
            _ctx.theme.isDark.value ? 'bg-gray-800 border-gray-700 hover:bg-gray-700' : 'bg-white border-gray-200 hover:bg-gray-50',
            'border rounded-lg p-6 transition-colors cursor-pointer block'
          ])
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", {
              class: _normalizeClass([
              _ctx.theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
              'text-lg font-semibold mb-2'
            ])
            }, " Mongo ", 2),
            _createElementVNode("p", {
              class: _normalizeClass([
              _ctx.theme.isDark.value ? 'text-gray-400' : 'text-gray-600',
              'text-sm'
            ])
            }, " View cluster and collections, indexes, and performance metrics for MongoDB. ", 2),
            _createElementVNode("span", {
              class: _normalizeClass([
              _ctx.theme.isDark.value ? 'text-blue-400' : 'text-blue-600',
              'text-sm font-medium mt-2 inline-block'
            ])
            }, " Open Mongo → ", 2)
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ])
  ]))
}